import { markExternalAuthChallengeShown } from '@src/features/payments/store/payment';
import type { AppDispatch } from '@src/core/store';

type CardinalApi = {
  on?: (event: string, handler: () => void) => void;
  off?: (event: string) => void;
};

const CHALLENGE_RENDER_EVENT = 'ui.render';

const cardinal = (): CardinalApi | undefined => (window as unknown as { Cardinal?: CardinalApi }).Cardinal;

/**
 * Braspag hands the challenge to Cardinal's songbird, loaded by `BP.Mpi.3ds20.min.js`, which puts
 * the bank screen up on `ui.render` — the frictionless flows never render one. The provider itself
 * has no callback for that moment: its config only reports the outcome.
 */
export const observeCardinalChallenge = (dispatch: AppDispatch): VoidFunction => {
  const api = cardinal();

  if (!api?.on) {
    return () => undefined;
  }

  api.on(CHALLENGE_RENDER_EVENT, () => dispatch(markExternalAuthChallengeShown()));

  return () => cardinal()?.off?.(CHALLENGE_RENDER_EVENT);
};

export default observeCardinalChallenge;
